<template>
  <div class="content" v-if="loadConfigurationGroupConfigurations">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6" >
      <card class="bg-transparent" >
        <template slot="header">
          <div style="display: flex;">
            <div>
              <h3 class="mb-0">{{ configurationGroup.name }}</h3>
              <p class="text-sm mb-0">
                Configuration group settings
              </p>
            </div>
            <div style="flex: 1.5; ">
              <base-button size="sm" type="neutral" @click.native="handleSave()" style="float: right;">Save</base-button>
            </div>
          </div>
        </template>
        <div>
          <b-tabs pills>
            <b-tab v-for="(tab, index) in configs" :key="tab.name" :title="tab.name">
              <p/>
                <div v-for="(config, idx) of tab.items">
                  <b-row>
                    <b-col md="3">
                      <base-input :label="config.title"
                                  :name="config.service + '.' + config.parameter"
                                  type="false"
                                  :required="true"
                                  v-model:value="configurationGroupConfigurations.groupConfigurations[getConfigIndex(config.service, config.parameter)].value"
                                  />
                    </b-col>
                    <b-col class="col-6 align-self-center">
                      {{ configurationGroupConfigurations.groupConfigurations[getConfigIndex(config.service, config.parameter)].deviceConfiguration.description }}
                    </b-col>
                  </b-row>
                  <div v-if="tab.name === 'Camera' && config.parameter.endsWith('CameraMask')">
                    <calculate-camera-mask :camera-mask="configurationGroupConfigurations.groupConfigurations[getConfigIndex(config.service, config.parameter)]" />
                  </div>
                  <div v-if="tab.name === 'Media' && config.parameter === 'paramEventCameraMask'">
                    <calculate-camera-event-mask :event-mask="configurationGroupConfigurations.groupConfigurations[getConfigIndex(config.service, config.parameter)]" />
                  </div>
                  <div v-if="tab.name === 'Alarm' && config.parameter === 'paramAlarmCameraMask'">
                    <calculate-camera-alarm-mask :camera-mask="configurationGroupConfigurations.groupConfigurations[getConfigIndex(config.service, config.parameter)]" />
                  </div>
                  <div v-if="tab.name === 'Live Feed' && config.parameter === 'paramLiveFeedCameraMask'">
                    <calculate-camera-mask :camera-mask="configurationGroupConfigurations.groupConfigurations[getConfigIndex(config.service, config.parameter)]" />
                  </div>
                </div>
            </b-tab>
          </b-tabs>
        </div>
      </card>
    </b-container>
  </div>
</template>

<script>
import crudApi from "../../crud/crud-api";
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import CalculateCameraMask from "./CalculateCameraMask";
import CalculateCameraAlarmMask from "./CalculateCameraAlarmMask";
import CalculateCameraEventMask from "./CalculateCameraEventMask";

export default {
  name: "ConfigurationGroupConfigurations",
  components: {
    CalculateCameraMask,
    CalculateCameraAlarmMask,
    CalculateCameraEventMask,
    RouteBreadCrumb,
  },
  props: {
    configurationGroup: {
      type: Object,
      required: true,
      description: "Configuration group"
    }
  },
  data: _ => ({
    updateValues: [],
    configurationGroupConfigurations: {},
    configs: [
      {
        name: "Weights",
        items: [
          {
            "title": "Coast",
            "parameter": "paramCoastWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Cruise",
            "parameter": "paramCruiseWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Driving behavior",
            "parameter": "paramDrivingBehaviorWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Harsh acceleration",
            "parameter": "paramHarshAccelerationWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Harsh brake",
            "parameter": "paramHarshBrakeWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Harsh pedal acceleration",
            "parameter": "paramHarshPedalAccelerationWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Idle",
            "parameter": "paramIdleWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Over RPM",
            "parameter": "paramOverRpmWeight",
            "service": "drivingstyleui"
          },
          {
            "title": "Over speed",
            "parameter": "paramOverSpeedWeight",
            "service": "drivingstyleui"
          }
        ],
      },
      {
        name: "Factors",
        items: [
          {
            "title": "Coast",
            "parameter": "paramCoastFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Cruise",
            "parameter": "paramCruiseTimeFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Driving behavior",
            "parameter": "paramDrivingBehaviorFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Harsh acceleration",
            "parameter": "paramHarshAccelerationFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Harsh brake",
            "parameter": "paramHarshBrakeFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Harsh pedal acceleration",
            "parameter": "paramHarshPedalAccelerationFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Idle",
            "parameter": "paramIdleFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Over RPM",
            "parameter": "paramOverRpmFactor",
            "service": "drivingstyleui"
          },
          {
            "title": "Over speed",
            "parameter": "paramOverSpeedFactor",
            "service": "drivingstyleui"
          }
        ],
      }, {
        name: "Configurations",
        items: [
          {
            "title": "Harsh acceleration",
            "parameter": "paramThrAccel",
            "service": "fms"
          },
          {
            "title": "Harsh brake",
            "parameter": "paramThrBrake",
            "service": "fms"
          },
          {
            "title": "RPM",
            "parameter": "paramThrRpm",
            "service": "fms"
          },
          {
            "title": "Speed",
            "parameter": "paramThrSpd",
            "service": "fms"
          },
          {
            "title": "Torque",
            "parameter": "paramThrTrq",
            "service": "fms"
          },
          {
            "title": "Pedal",
            "parameter": "paramThrAccPed",
            "service": "fms"
          },
          {
            "title": "Acceleration",
            "parameter": "paramThrAccelDT",
            "service": "fms"
          },
          {
            "title": "Deceleration",
            "parameter": "paramThrDecelDT",
            "service": "fms"
          },
          {
            "title": "Drive speed",
            "parameter": "paramDriveSpeed",
            "service": "fms"
          },
        ]
      },
      {
        name: "Thresholds",
        items: [
          {
            "title": "Coastable distance",
            "parameter": "paramCoastableDistanceThreshold",
            "service": "drivingstyleui"
          },
          {
            "title": "Cruise time",
            "parameter": "paramCruiseTimeThreshold",
            "service": "drivingstyleui"
          },
          {
            "title": "Cruiseable speed",
            "parameter": "paramCruisableSpeed",
            "service": "drivingstyle"
          },
          {
            "title": "Idle time",
            "parameter": "paramIdleThreshold",
            "service":"drivingstyle"
          },
          {
            "title": "Over RPM",
            "parameter": "paramOverRPMThreshold",
            "service":"drivingstyle"
          },
          {
            "title": "Over speed",
            "parameter": "paramOverSpeedThreshold",
            "service":"drivingstyle"
          },
          {
            "title": "Harsh acceleration speed",
            "parameter": "paramThrAccPedSpeed",
            "service":"fms"
          },
          {
            "title": "Stop speed",
            "parameter": "paramThrVehicleStopSpeed",
            "service":"fms"
          },
          {
            "title": "Brake speed",
            "parameter": "paramThrBrakeSpeed",
            "service":"fms"
          },
          {
            "title": "Fuel level delay",
            "parameter": "paramEventFuelLevelDelay",
            "service":"fms"
          },
        ]
      }, {
        name: "Trips",
        items: [
          {
            "title": "Ignition",
            "parameter": "paramTripFromIgnition",
            "service": "drivingstyle2"
          },
          {
            "title": "Ignition timeout",
            "parameter": "paramIgnitionTimeout",
            "service": "drivingstyle2"
          },
          {
            "title": "Movement",
            "parameter": "paramTripFromMovement",
            "service": "drivingstyle2"
          },
          {
            "title": "Engine",
            "parameter": "paramTripFromEngine",
            "service": "drivingstyle2"
          },
        ]
      }, {
        name: "Periodical",
        items: [
          {
            "title": "Frequency while moving",
            "parameter": "paramSendFreqMoving",
            "service": "drivingstyle2"
          },
          {
            "title": "Frequency while standing still",
            "parameter": "paramSendFreqNotMoving",
            "service": "drivingstyle2"
          },
        ]
      }, {
        name: "Incidents",
        items: [
          {
            "title": "Record time",
            "parameter": "paramEdrThrTime",
            "service":"fms"
          },
          {
            "title": "Minimum speed",
            "parameter": "paramEdrThrMinSpeed",
            "service":"fms"
          },
          {
            "title": "Acceleration",
            "parameter": "paramEdrThrAccel",
            "service":"fms"
          },
          {
            "title": "Brake",
            "parameter": "paramEdrThrDecel",
            "service":"fms"
          }
        ]
      }, {
        name: "Camera",
        items: [
          {
            "title": "Always record",
            "parameter": "paramAlwaysRecord",
            "service":"camera"
          },
          {
            "title": "Cameras to record",
            "parameter": "paramRecordCameraMask",
            "service":"camera"
          },
          {
            "title": "Cameras to display",
            "parameter": "paramDisplayCameraMask",
            "service":"camera"
          },
          {
            "title": "Enable OSD",
            "parameter": "paramEnableOSD",
            "service":"camera"
          },
          {
            "title": "Use ranking for overlay",
            "parameter": "paramOverlayUseRanking",
            "service":"camera"
          },
          {
            "title": "Overlay front camera after ignition on",
            "parameter": "paramShowFrontIgnitionUnderSpeed",
            "service":"camera"
          },
          {
            "title": "CanBus mask for use in overlay",
            "parameter": "paramCanBusMask",
            "service":"camera"
          },
          {
            "title": "Camera 1 resolution",
            "parameter": "paramCamera1Resolution",
            "service":"camera"
          },
          {
            "title": "Camera 1 video mode",
            "parameter": "paramCamera1VideoMode",
            "service":"camera"
          },
          {
            "title": "Camera 1 mirrored",
            "parameter": "paramCamera1Mirrored",
            "service":"camera"
          },
          {
            "title": "Camera 1 IO",
            "parameter": "paramCamera1IO",
            "service":"camera"
          },
          {
            "title": "Camera 1 rank",
            "parameter": "paramCamera1Rank",
            "service":"camera"
          },
          {
            "title": "Camera 1 hide delay",
            "parameter": "paramCamera1HideDelay",
            "service":"camera"
          },
          {
            "title": "Camera 1 overlay activate cameras",
            "parameter": "paramCamera1OverlayCameraMask",
            "service":"camera"
          },
          {
            "title": "Camera 2 resolution",
            "parameter": "paramCamera2Resolution",
            "service":"camera"
          },
          {
            "title": "Camera 2 video mode",
            "parameter": "paramCamera2VideoMode",
            "service":"camera"
          },
          {
            "title": "Camera 2 mirrored",
            "parameter": "paramCamera2Mirrored",
            "service":"camera"
          },
          {
            "title": "Camera 2 IO",
            "parameter": "paramCamera2IO",
            "service":"camera"
          },
          {
            "title": "Camera 2 rank",
            "parameter": "paramCamera2Rank",
            "service":"camera"
          },
          {
            "title": "Camera 2 hide delay",
            "parameter": "paramCamera2HideDelay",
            "service":"camera"
          },
          {
            "title": "Camera 2 overlay activate cameras",
            "parameter": "paramCamera2OverlayCameraMask",
            "service":"camera"
          },
          {
            "title": "Camera 3 resolution",
            "parameter": "paramCamera3Resolution",
            "service":"camera"
          },
          {
            "title": "Camera 3 video mode",
            "parameter": "paramCamera3VideoMode",
            "service":"camera"
          },
          {
            "title": "Camera 3 mirrored",
            "parameter": "paramCamera3Mirrored",
            "service":"camera"
          },
          {
            "title": "Camera 3 IO",
            "parameter": "paramCamera3IO",
            "service":"camera"
          },
          {
            "title": "Camera 3 rank",
            "parameter": "paramCamera3Rank",
            "service":"camera"
          },
          {
            "title": "Camera 3 hide delay",
            "parameter": "paramCamera3HideDelay",
            "service":"camera"
          },
          {
            "title": "Camera 3 overlay activate cameras",
            "parameter": "paramCamera3OverlayCameraMask",
            "service":"camera"
          },
          {
            "title": "Camera 4 resolution",
            "parameter": "paramCamera4Resolution",
            "service":"camera"
          },
          {
            "title": "Camera 4 video mode",
            "parameter": "paramCamera4VideoMode",
            "service":"camera"
          },
          {
            "title": "Camera 4 mirrored",
            "parameter": "paramCamera4Mirrored",
            "service":"camera"
          },
          {
            "title": "Camera 4 IO",
            "parameter": "paramCamera4IO",
            "service":"camera"
          },
          {
            "title": "Camera 4 rank",
            "parameter": "paramCamera4Rank",
            "service":"camera"
          },
          {
            "title": "Camera 4 hide delay",
            "parameter": "paramCamera4HideDelay",
            "service":"camera"
          },
          {
            "title": "Camera 4 overlay activate cameras",
            "parameter": "paramCamera4OverlayCameraMask",
            "service":"camera"
          },
        ]
      }, {
        name: "Media",
        items: [
          {
            "title": "Send media over WiFi",
            "parameter": "paramSendMediaOverWifi",
            "service":"drivingstyle2"
          },
          {
            "title": "Camera event mask",
            "parameter": "paramEventCameraMask",
            "service":"drivingstyle2"
          },
          {
            "title": "Video duration before event",
            "parameter": "paramVideoDurationBeforeEvent",
            "service":"drivingstyle2"
          },
          {
            "title": "Video duration after event",
            "parameter": "paramVideoDurationAfterEvent",
            "service":"drivingstyle2"
          },
        ]
      }, {
        name: "Alarm",
        items: [
          {
            "title": "Camera alarm mask",
            "parameter": "paramAlarmCameraMask",
            "service": "drivingstyle2"
          },
          {
            "title": "Video duration before alarm",
            "parameter": "paramVideoDurationBeforeAlarm",
            "service":"drivingstyle2"
          },
          {
            "title": "Video duration after alarm",
            "parameter": "paramVideoDurationAfterAlarm",
            "service":"drivingstyle2"
          },
          {
            "title": "Frequency while alarm is active",
            "parameter": "paramSendFreqAlarm",
            "service":"drivingstyle2"
          },
        ]
      }, {
        name: "Live Feed",
        items: [
          {
            "title": "Live feed camera mask",
            "parameter": "paramLiveFeedCameraMask",
            "service": "camera"
          },
          {
            "title": "Live feed video width",
            "parameter": "paramLiveFeedVideoWidth",
            "service": "camera"
          },
          {
            "title": "Live feed video height",
            "parameter": "paramLiveFeedVideoHeight",
            "service": "camera"
          },
          {
            "title": "Live feed video FPS",
            "parameter": "paramLiveFeedVideoFps",
            "service": "camera"
          },
        ]
      }, {
        name: "Levels",
        items: [
          {
            "title": "Warning",
            "parameter": "paramWarningLevel",
            "service":"drivingstyleui"
          },
          {
            "title": "Critical",
            "parameter": "paramCriticalLevel",
            "service":"drivingstyleui"
          }
        ]
      }
    ]
  }),
  computed: {
    loadConfigurationGroupConfigurations() {
      crudApi.getConfigurationGroupConfigurations(this.configurationGroup.id).then(json => this.configurationGroupConfigurations = json.data ? json.data : json)

      return true
    },
  },
  methods: {
    getConfigIndex(service, parameter) {
      let idx = 0

      for (let groupConfiguration of this.configurationGroupConfigurations.groupConfigurations) {
        if (service === groupConfiguration.deviceConfiguration.service && parameter === groupConfiguration.deviceConfiguration.parameter) {
          return idx
        }

        idx++
      }

      return -1
    },
    handleSave() {
      let updates = []

      for (let groupConfiguration of this.configurationGroupConfigurations.groupConfigurations) {
        updates.push({ "deviceConfigurationId": groupConfiguration.deviceConfigurationId, "value": groupConfiguration.value })
      }

      crudApi.updateConfigurationGroupConfigurations(this.configurationGroup.id, updates)
    }
  }
}
</script>

<style scoped>

</style>
